import styled from 'styled-components'



export const Container = styled.div`
    background: #fff;
    border-radius: 0px;
    margin: 30px 0;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;

   @media (min-width: 768px) {
    border-radius: 5px;
    width: 100%;
   }

   [type="radio"]:checked,
[type="radio"]:not(:checked) {
  position: absolute;
  left: -9999px;
}
[type="radio"]:checked + label,
[type="radio"]:not(:checked) + label {
  position: relative;
  padding-left: 28px;
  cursor: pointer;
  line-height: 20px;
  display: inline-block;
  color: #666;
}
[type="radio"]:checked + label:before,
[type="radio"]:not(:checked) + label:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 18px;
  height: 18px;
  border: 1px solid #ddd;
  border-radius: 100%;
  background: #fff;
}
[type="radio"]:checked + label:after,
[type="radio"]:not(:checked) + label:after {
  content: "";
  width: 12px;
  height: 12px;
  background: #f87da9;
  position: absolute;
  top: 4px;
  left: 4px;
  border-radius: 100%;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
[type="radio"]:not(:checked) + label:after {
  opacity: 0;
  -webkit-transform: scale(0);
  transform: scale(0);
}
[type="radio"]:checked + label:after {
  opacity: 1;
  -webkit-transform: scale(1);
  transform: scale(1);
}
`

export const ContenedorRespuesta = styled.p`
    padding-left:50px;
`

export const ContenedorPregunta = styled.div`
    padding-left:25px;
    padding-bottom:10px;
`

export const ContenedorPreguntas = styled.div`
    padding:20px;
`
export const ContenedorSend = styled.div`
    padding:20px;
`

export const ContenedorGracias = styled.p`
padding:50px;
`

export const Btnpreguntar = styled.div`
    background: #D9A76A;
    color: #fff;
    margin-left: 0px;
    border-radius: 4px;
    border: #D9A76A solid 1px;
    display: inline-flex;
    text-transform: uppercase;
    cursor: pointer;
    margin-right: 13px;
    font-size: 14px;
    padding: 8px 14px;

    &:hover{
        opacity:.8;
    }
`



